import React from "react";
import { Svg } from "../componet/Orientation/style";

function Icon() {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      fill="none"
      viewBox="0 0 36 36"
      group="true"
    >
      <path
        fill="#A71B38"
        d="M27.137 28.491a3.606 3.606 0 10-5.944-2.743 3.614 3.614 0 00-7.22 0 3.578 3.578 0 001.275 2.743 5.161 5.161 0 00-1.266.941c-.37-.382-.8-.7-1.275-.94a3.606 3.606 0 10-4.678 0 5.117 5.117 0 00-2.753 4.52v1.441a.721.721 0 00.713.721h23.18a.73.73 0 00.73-.72V33.01a5.12 5.12 0 00-2.762-4.52zm-2.339-4.906a2.163 2.163 0 110 4.327 2.163 2.163 0 010-4.327zm-3.605 2.163a3.606 3.606 0 001.257 2.743 5.089 5.089 0 00-1.275.941 5.109 5.109 0 00-1.257-.94 3.605 3.605 0 001.275-2.744zm-3.606-2.163a2.164 2.164 0 11-2.154 2.163 2.173 2.173 0 012.154-2.163zm-7.21 0a2.163 2.163 0 110 4.326 2.163 2.163 0 010-4.326zm2.172 9.426v.721h-5.84v-.72a3.711 3.711 0 013.659-3.659 3.613 3.613 0 012.752 1.275 5.162 5.162 0 00-.58 2.383h.009zm8.661.721h-7.237v-.72a3.615 3.615 0 017.228 0v.72h.01zm7.264 0h-5.84v-.72c.003-.831-.2-1.65-.588-2.384a3.615 3.615 0 012.752-1.275 3.72 3.72 0 013.667 3.658l.009.721zM22.16 13.912l-2.761-.396-1.24-2.56a.73.73 0 00-1.302 0l-1.24 2.56-2.76.396a.73.73 0 00-.405 1.23l2.005 1.953-.475 2.76a.73.73 0 001.055.766l2.471-1.275 2.48 1.31a.73.73 0 001.046-.765l-.474-2.761 2.004-1.952a.721.721 0 00-.404-1.231v-.035zm-2.884 2.418a.723.723 0 00-.203.642l.273 1.688-1.521-.8a.746.746 0 00-.669 0l-1.52.8.29-1.688a.72.72 0 00-.203-.642l-1.231-1.196 1.697-.246a.72.72 0 00.545-.405l.757-1.556.756 1.556a.72.72 0 00.545.405l1.706.246-1.222 1.196z"
      ></path>
      <g fill="#A71B38" opacity="0.25">
        <path
          d="M34.374 9.594a.756.756 0 00-.8.8v15.987a.757.757 0 01-.8.8h-2.076a.8.8 0 100 1.6h2.076a2.355 2.355 0 002.4-2.4V10.394a.757.757 0 00-.8-.8zM4.802 4.001a.809.809 0 01-.81.8.8.8 0 11.81-.8zM7.193 4.001a.8.8 0 11-1.6 0 .8.8 0 011.6 0zM9.594 4.001a.8.8 0 11-1.6 0 .8.8 0 011.6 0zM31.182 3.201H11.995a.757.757 0 00-.8.8.757.757 0 00.8.8h19.187a.756.756 0 00.791-.8.748.748 0 00-.791-.8z"
          opacity="0.25"
        ></path>
        <path
          d="M32.774 0H2.4a2.357 2.357 0 00-2.4 2.401v23.98a2.357 2.357 0 002.4 2.4h2.075a.8.8 0 100-1.6H2.401a.756.756 0 01-.8-.8V2.4a.756.756 0 01.8-.8h30.373a.756.756 0 01.8.8v3.992H3.993a.756.756 0 00-.792.8.747.747 0 00.792.8h30.381a.756.756 0 00.8-.8V2.401a2.357 2.357 0 00-2.4-2.4z"
          opacity="0.25"
        ></path>
      </g>
    </Svg>
  );
}

export default Icon;
